import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { resolveImageUrl } from "@/lib/media";
import { ArrowRight } from "lucide-react";

export const CTASection = ({ cta }) => {
  const isExternal = /^https?:\/\//.test(cta.button_link || "");
  const style = cta.bg_type === "image"
    ? { backgroundImage: `url(${resolveImageUrl(cta.bg_value)})`, backgroundSize: "cover", backgroundPosition: "center" }
    : { backgroundColor: cta.bg_value };

  return (
    <div data-testid={`cta-block-${cta.id}`} className="relative p-10 md:p-14 text-white overflow-hidden" style={style}>
      {cta.bg_type === "image" && <div className="absolute inset-0 bg-black/50" />}
      <div className="relative max-w-xl">
        <h3 className="font-heading text-2xl md:text-3xl mb-3">{cta.heading}</h3>
        {cta.description && <p className="text-white/85 mb-6 leading-relaxed">{cta.description}</p>}
        <Button asChild className="rounded-none bg-accent text-accent-foreground hover:opacity-90 group">
          {isExternal ? (
            <a href={cta.button_link} target="_blank" rel="noopener noreferrer">
              {cta.button_text} <ArrowRight className="h-4 w-4 ml-2 transition-transform group-hover:translate-x-1" />
            </a>
          ) : (
            <Link to={cta.button_link || "/"}>
              {cta.button_text} <ArrowRight className="h-4 w-4 ml-2 transition-transform group-hover:translate-x-1" />
            </Link>
          )}
        </Button>
      </div>
    </div>
  );
};
